const { getCookie } = require("@ali/fast-utils");

class CleanLogin {
  constructor() {
    this.Init();
  }

  GetHosts(from) {
    let target = window.location.href;
    if (target.indexOf('?') > -1) {
      let tmpArr = target.split('?');
      target = `${tmpArr[0]}${encodeURIComponent(`?${tmpArr[1]}`)}`;
    }
    const curURrl = `https://www.9game.cn/login/rcd?action=${from}&redirect=${encodeURIComponent(target)}`;
    // 由于获取用户uid的cookie需要在门户页面写入，所以投放页面的九游都要先跳转到首页后，在跳回问答页
    // console.log('curURrl =====>', curURrl);
    return encodeURIComponent(curURrl);
  }

  Init() {
    const ng_session_id = getCookie('ng_session_id') || '';
    const current_uid = getCookie('current_uid') || '';
    const current_nickname = getCookie('current_nickname') || '';
    if (ng_session_id) {
      if ((current_uid == '' || current_uid == '0') || current_nickname == '') {
        // 同步云游登陆态
        $.ajax({
          type: 'GET',
          url: `https://www.9game.cn/loginInfoSync?retUrl=${this.GetHosts('login')}`,
          data: {},
          timeout: 4000,
          success(data, statusText) {
            console.log('data ==>', data);
            console.log('statusText ==>', statusText);
          },
          error() {
          }
        });
      }
    }
  }
}

new CleanLogin();



// WEBPACK FOOTER //
// ./jws/views/page/rclearLogin/index.js